import { Box, Button } from "@mui/material";
import { Link as DomLink } from "react-router-dom";
import ShapeFilter from "../../diamonds/controls/filters/ShapeFilter";
import Range from "../../diamonds/controls/filters/Range";
import { GemstoneColors } from "../GemstoneColors";
import CheckBox from "./CheckBoxes";
import { GemstoneTypes } from "../GemstoneType";
import { GemstoneSearchContext } from "../../../utils/stateHandlers/contexts";
import { useContext } from "react";
export const FilterContent = ({
  filter,
  resetFilters,
  updateRange,
  loggedIn,
  sendTo,
  updateCheckedBoxes,
}) => {
  const { gemstoneState, dispatch } = useContext(GemstoneSearchContext);
  const { searchQuery } = gemstoneState;
  const containerStyles = {
    paddingLeft: "3rem",
    paddingRight: "3rem",
    width: "93%",
  };

  const renderContent = () => {
    const { type, label, name } = filter;
    if (type === "options" && label === "Shape") {
      return <ShapeFilter state={gemstoneState} dispatch={dispatch} />;
    }
    if (type === "options" && label !== "Shape") {
      return (
        <CheckBox
          search={searchQuery}
          filter={filter}
          resetFilters={resetFilters}
          updateCheckedBoxes={updateCheckedBoxes}
        />
      );
    }
    if (type === "enum") {
      if (name === "Color") {
        return (
          <GemstoneColors
            filter={filter}
            searchQuery={searchQuery}
            dispatch={dispatch}
          />
        );
      }
      if (name === "Gemstone") {
        return (
          <GemstoneTypes
            filter={filter}
            searchQuery={searchQuery}
            dispatch={dispatch}
          />
        );
      }
    }

    if (type === "numeric") {
      if (name === "HooverPrice") {
        return loggedIn ? (
          <Range
            filter={filter}
            resetFilters={resetFilters}
            updateRange={updateRange}
          />
        ) : (
          <DomLink
            to={{ pathname: "/login", state: { sendTo: sendTo.pathname } }}
          >
            <Button variant="contained" color="error">
              Login For pricing
            </Button>
          </DomLink>
        );
      }

      return (
        <Range
          filter={filter}
          resetFilters={resetFilters}
          updateRange={updateRange}
        />
      );
    }

    return null;
  };

  return <Box sx={containerStyles}>{renderContent()}</Box>;
};
